import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'center',
  padding: '5rem',

  borderRadius: '1.2rem',

  backgroundColor: theme.colors.base06,

  '& > svg': {
    width: '100%',
    height: 'auto',
    borderRadius: 'inherit',
  },
}));
